import { createFileRoute } from "@tanstack/react-router";

import { Valuation } from "~/components/feature/valuation";
export const Route = createFileRoute("/_app/dashboard/valuation")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Valuation />;
}
